import React, { useState, useEffect } from 'react';
import { Alert, ProgressBar } from 'react-bootstrap';
import _ from 'lodash';
import useDataApi from '../../utils/useDataApi';
import usePostApi from '../../utils/usePostApi';

import Petition from './Petition';

const type = 'petition';

export default function (drupalParams) {
  const { case_uuid, canEdit, can_see_details } = drupalParams;
  const [{ data, isLoading, isError }, { setData }] = useDataApi(
    `/ir-search/query-json?query=${type}&case_uuid=${case_uuid}`,
    {}
  );
  const [editScheduleForm, setEditScheduleForm] = useState(false);
  const [dataForSave, setDataForSave] = useState(false);

  const transformResponseToData = (response) => {
    let schedule = {};
    const queries = Array.isArray(response.queries)
      ? _.get(response, 'queries[0].petition[0].text', [])
      : _.get(response, 'queries.petition[0].text', []);

    const headers = Array.isArray(response.items)
      ? _.get(response, 'items[0].headers[0].text', [])
      : _.get(response, 'items.headers[0].text', []);
    const { data: responseData = {}, empty = null } = queries;
    const {
      website = '',
      assets: estimated_assets = '',
      ch11_type = '',
      industry: naics = '',
      liabilities: estimated_liabilities = '',
    } = headers;
    schedule = {
      ...queries,
      data: responseData || {},
      empty,
      header: { website, estimated_assets, ch11_type, naics, estimated_liabilities },
    };
    return schedule;
  };

  const [{ data: savedScheduleResponse, isLoading: isLoadingSave, isError: isSaveError }, setPostData] =
    usePostApi('/scheduleform/save');
  const [{ data: savedSummaryResponse, isLoading: isLoadingSummary, isError: isSummaryError }, setPostSummaryData] =
    usePostApi('/pacercaseeditor/save-summary');

  useEffect(() => {
    if (savedScheduleResponse) setData(savedScheduleResponse.content);
  }, [savedScheduleResponse]);

  useEffect(() => {
    if (savedSummaryResponse) {
      setPostData({
        case_uuid,
        type,
        data: dataForSave,
      });
      setEditScheduleForm(false);
    }
  }, [savedSummaryResponse]);

  const saveScheduleForm = (values) => {
    const statisticalSummary = {
      assets: values.estimated_assets ? values.estimated_assets : 'Unknown',
      case_uuid,
      ch11_type: values.ch11_type ? values.ch11_type : '',
      industry: values.naics ? values.naics : '',
      liabilities: values.estimated_liabilities ? values.estimated_liabilities : 'Unknown',
      website: values.website ? values.website : '',
    };
    // prettier-ignore
    const formData = {
      estimated_number_of_creditors       : values.estimated_number_of_creditors || '',
      describe_debtor_business            : values.describe_debtor_business || '',
      principal_place_of_business_street  : values.principal_place_of_business_street || '',
      principal_place_of_business_city    : values.principal_place_of_business_city || '',
      principal_place_of_business_state   : values.principal_place_of_business_state || '',
      principal_place_of_business_zip_code: values.principal_place_of_business_zip_code || '',
      principal_place_of_business_country : values.principal_place_of_business_country || '',
      location_place_of_business_street   : values.location_place_of_business_street || '',
      location_place_of_business_city     : values.location_place_of_business_city || '',
      location_place_of_business_state    : values.location_place_of_business_state || '',
      location_place_of_business_zip_code : values.location_place_of_business_zip_code || '',
      location_place_of_business_country  : values.location_place_of_business_country || '',
      authorized_representative_of_debtor : values.authorized_representative_of_debtor || '',
      title                               : values.title || '',
    };
    setDataForSave(formData);
    setPostSummaryData(statisticalSummary);
  };

  const toggleScheduleForm = () => {
    setEditScheduleForm(!editScheduleForm);
  };

  if (isLoading || isLoadingSave || isLoadingSummary) {
    return (
      <ProgressBar
        now={100}
        bsStyle="info"
        label={`${isLoadingSave || isLoadingSummary ? 'Saving in progress' : ''}`}
        active
      />
    );
  }

  if (isError || isSaveError || isSummaryError) {
    return <Alert bsStyle="danger">There has been an error {`${isError ? 'loading' : 'saving'}`} Schedule data.</Alert>;
  }

  return (
    <Petition
      schedule={transformResponseToData(data)}
      canEdit={canEdit}
      can_see_details={can_see_details}
      type={type}
      editScheduleForm={editScheduleForm}
      toggleScheduleForm={toggleScheduleForm}
      onSubmit={(value) => saveScheduleForm(value)}
      onCancel={toggleScheduleForm}
    />
  );
}



// WEBPACK FOOTER //
// ./src/scheduleform/petition/PetitionContainer.jsx